import Marquee from "react-fast-marquee";

const ScrollingText = () => {
  return (
    <div className="marquee-wrapper">
      <Marquee direction="left" speed={120} loop={0}>
        <img src="/images/Marquee/audi-logo.svg" alt="" />
        <img src="/images/Marquee/vw-logo.svg" alt="" />
        <img src="/images/Marquee/skoda-logo.svg" alt="" />
        <img src="/images/Marquee/seat-logo.svg" alt="" />
        <img src="/images/Marquee/porsche-logo.svg" alt="" />

        <img src="/images/Marquee/ford-logo.svg" alt="" />

        <img src="/images/Marquee/audi-logo.svg" alt="" />
        <img src="/images/Marquee/vw-logo.svg" alt="" />
        <img src="/images/Marquee/skoda-logo.svg" alt="" />
        <img src="/images/Marquee/seat-logo.svg" alt="" />
        <img src="/images/Marquee/porsche-logo.svg" alt="" />

        <img src="/images/Marquee/ford-logo.svg" alt="" />

        <img src="/images/Marquee/audi-logo.svg" alt="" />
        <img src="/images/Marquee/vw-logo.svg" alt="" />
        <img src="/images/Marquee/skoda-logo.svg" alt="" />
        <img src="/images/Marquee/seat-logo.svg" alt="" />
        <img src="/images/Marquee/porsche-logo.svg" alt="" />

        <img src="/images/Marquee/ford-logo.svg" alt="" />

        <img src="/images/Marquee/audi-logo.svg" alt="" />
        <img src="/images/Marquee/vw-logo.svg" alt="" />
        <img src="/images/Marquee/skoda-logo.svg" alt="" />
        <img src="/images/Marquee/seat-logo.svg" alt="" />
        <img src="/images/Marquee/porsche-logo.svg" alt="" />

        <img src="/images/Marquee/ford-logo.svg" alt="" />

        <img src="/images/Marquee/audi-logo.svg" alt="" />
        <img src="/images/Marquee/vw-logo.svg" alt="" />
        <img src="/images/Marquee/skoda-logo.svg" alt="" />
        <img src="/images/Marquee/seat-logo.svg" alt="" />
        <img src="/images/Marquee/porsche-logo.svg" alt="" />

        <img src="/images/Marquee/ford-logo.svg" alt="" />

        <img src="/images/Marquee/audi-logo.svg" alt="" />
        <img src="/images/Marquee/vw-logo.svg" alt="" />
        <img src="/images/Marquee/skoda-logo.svg" alt="" />
        <img src="/images/Marquee/seat-logo.svg" alt="" />
        <img src="/images/Marquee/porsche-logo.svg" alt="" />

        <img src="/images/Marquee/ford-logo.svg" alt="" />

        <img src="/images/Marquee/audi-logo.svg" alt="" />
        <img src="/images/Marquee/vw-logo.svg" alt="" />
        <img src="/images/Marquee/skoda-logo.svg" alt="" />
        <img src="/images/Marquee/seat-logo.svg" alt="" />
        <img src="/images/Marquee/porsche-logo.svg" alt="" />

        <img src="/images/Marquee/ford-logo.svg" alt="" />

        <img src="/images/Marquee/audi-logo.svg" alt="" />
        <img src="/images/Marquee/vw-logo.svg" alt="" />
        <img src="/images/Marquee/skoda-logo.svg" alt="" />
        <img src="/images/Marquee/seat-logo.svg" alt="" />
        <img src="/images/Marquee/porsche-logo.svg" alt="" />

        <img src="/images/Marquee/ford-logo.svg" alt="" />

        <img src="/images/Marquee/audi-logo.svg" alt="" />
        <img src="/images/Marquee/vw-logo.svg" alt="" />
        <img src="/images/Marquee/skoda-logo.svg" alt="" />
        <img src="/images/Marquee/seat-logo.svg" alt="" />
        <img src="/images/Marquee/porsche-logo.svg" alt="" />

        <img src="/images/Marquee/ford-logo.svg" alt="" />
      </Marquee>
    </div>
  );
};

export default ScrollingText;
